/**
 * ВНЕ-REACT КЛЕЙ ПРОВЕРКИ ОБНОВЛЕНИЯ — интервал между проверками, открытие
 * ссылки на APK, формат размера. Отделён от UpdateDialog.tsx (там механика
 * и разметка), чтобы App.tsx не знал про localStorage-ключи и не тащил
 * константы интервалов в тело компонента.
 *
 * ИНТЕРВАЛ: не чаще одного раза в 30 минут (разумный компромисс: человек,
 * вернувшийся в приложение через час, обновление увидит; человек,
 * сворачивающий-разворачивающий приложение каждые 5 минут, сервер не
 * долбит). Отметка времени ПОСЛЕДНЕЙ ПОПЫТКИ (не успеха: иначе при
 * отсутствии сети мы стучались бы на каждый фокус) — в localStorage
 * `alg.update.checkedAt`, поэтому интервал переживает перезапуск
 * приложения. localStorage недоступен (приватный режим и т.п.) → разрешаем
 * проверку: в таком окружении и fetch, скорее всего, не пройдёт, а молчание
 * здесь безопаснее паранойи.
 */

/** Минимальный интервал между проверками: 30 минут. */
export const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;

const CHECKED_AT_KEY = "alg.update.checkedAt";

/** Пора проверять обновление? true — последняя попытка была давно/никогда. */
export function shouldCheckNow(now = Date.now()): boolean {
  try {
    const raw = window.localStorage.getItem(CHECKED_AT_KEY);
    if (!raw) return true;
    const at = Number.parseInt(raw, 10);
    if (!Number.isFinite(at)) return true;
    return now - at >= UPDATE_CHECK_INTERVAL_MS;
  } catch {
    return true;
  }
}

/** Отметить, что попытка проверки была (независимо от её исхода). */
export function markChecked(now = Date.now()): void {
  try {
    window.localStorage.setItem(CHECKED_AT_KEY, String(now));
  } catch {
    /* приватный режим: интервал не запомнится, но и не сломается ничего */
  }
}

/**
 * Открыть ссылку на APK штатным способом — тем же, которым приложение
 * открывает внешние ссылки (window.open с noopener, см. approveDeviceCode
 * в matrix/profile.ts). В Android WebView системный загрузчик сам перехватит
 * application/vnd.android.package-archive/APK-URL и скачает файл.
 */
export function openUpdateUrl(url: string): void {
  window.open(url, "_blank", "noopener");
}

/** Размер файла по-человечески: 7 690 575 байт → "7,3 МБ" (по локали). */
export function formatUpdateSize(bytes: number, locale: string): string {
  const mb = bytes / (1024 * 1024);
  const rounded = Math.round(mb * 10) / 10;
  const value = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(rounded);
  // «МБ» — единица, а не переводимая строка: во всех четырёх языках
  // интерфейса мегабайт пишется так (ru/en/es/pt-br одинаково).
  return `${value} МБ`;
}
